import * as basicScroll from 'basicscroll'

const fadeElem = document.querySelector('.image-fade')

if (fadeElem) {
const imageFade = basicScroll.create({
    elem: fadeElem,
    from: 'top-bottom',
    to: 'top-top',
    direct: true,
    props: {
       '--filter': {
          from: '.01',
          to: '0.99'
       },
    }
 })
 
    imageFade.start()
 }
 